import { render, staticRenderFns } from "./DelegacionesOpcionales.vue?vue&type=template&id=3b0c63d4&scoped=true"
import script from "./DelegacionesOpcionales.vue?vue&type=script&lang=ts"
export * from "./DelegacionesOpcionales.vue?vue&type=script&lang=ts"
import style0 from "./DelegacionesOpcionales.vue?vue&type=style&index=0&id=3b0c63d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0c63d4",
  null
  
)

export default component.exports